import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ErrorService {
    latesterror: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor() { }

    insertError(error: string) {
        this.latesterror.next(error);
    }
}